import { StrictMode, useEffect } from 'react';

import { useAuth0 } from '@auth0/auth0-react';
import { TooltipProvider } from '@radix-ui/react-tooltip';
import { useSelector } from 'react-redux';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { useDispatch } from '@/lib/redux/useDispatch';
import { actions } from '@/redux/actions';

import { SidebarProvider } from './components/ui/sidebar';
import { Toaster } from './components/ui/toaster';
import { setAuth0Client } from './lib/utils/auth0Client';
import { userLoadingSelector, userSelector } from './redux/user/selectors';
import { routes } from './routes';

import './App.scss';

const router = createBrowserRouter(routes);

const App: React.FC = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = setAuth0Client(useAuth0());
  const dispatch = useDispatch();
  const userLoading = useSelector(userLoadingSelector);
  const user = useSelector(userSelector);

  useEffect(() => {
    if (isAuthenticated) {
      if (!userLoading && !user) {
        dispatch(actions.getMe());
      }
    }
  }, [isAuthenticated, userLoading, user, dispatch]);

  if ((isLoading || userLoading) && !user) {
    return <div></div>;
  }

  if (!isAuthenticated) {
    loginWithRedirect();
    return <div></div>;
  }

  return (
    <StrictMode>
      <div className="relative flex min-h-screen flex-col bg-background">
        <SidebarProvider>
          <TooltipProvider>
            <RouterProvider router={router} />
            <Toaster />
          </TooltipProvider>
        </SidebarProvider>
      </div>
    </StrictMode>
  );
};

export default App;
